import ApiService from "./api.service";

function getPrefix(prefix) {
  return (prefix === 'subcontractor') ? 'subcontractor' : 'employee';
}

const userManager = {
  changeEmail: async function (user_id, data, prefix) {
    await ApiService.patch("/" + getPrefix(prefix) + "/" + user_id + "/login", data, "Email address changed");
    return true;
  },
  ChangePassword: async function (user_id, data, prefix) {
    await ApiService.patch("/" + getPrefix(prefix) + "/" + user_id + "/password", data, "Password has been changed");
    return true;
  },
  changeStatus: async function (user_id, newStatus, prefix) {
    let data = {
      'status': newStatus
    };
    let msg = newStatus === 'active' ? "User was activated" : "User was deactivated";
    await ApiService.patch("/" + getPrefix(prefix) + "/" + user_id + "/status", data, msg);
    return true;
  },
  changeRole: async function (user_id, newRole) {
    await ApiService.patch("/employee/" + user_id + "/role", {
      role: newRole
    }, "User permissions was changed");
    return true;
  },
  classBadge: function(value) {
    return {
      badge: true,
      "badge-success": value === "active",
      "badge-secondary": value !== "active" && value !== "disabled",
      "badge-danger": value === "disabled"
    };
  }
};

export default userManager;